export default __webpack_public_path__ + "static/media/saint_aubinmini.740ca46a.jpg";